import axios from 'axios';

const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    rootMargin: '0px',
    threshold: 0.01,
});

const home_url = window.location.origin;
const single_post_id_global = document.querySelector('#single_post_id_global')?.value ?? '';

const posts_ids_views = [single_post_id_global];

document.querySelectorAll('.infinity-post').forEach(item => {
    observer.observe(item);
});

function handleIntersection(entries, observer) {
    
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const post_id = entry.target.querySelector('[name="post_id"]').value;
            const post_link = entry.target.querySelector('[name="post_link"]').value;

            history.pushState({}, document.title, post_link);

            if (!posts_ids_views.includes(post_id)) {
                axios.get(api_settings.ajax_url, {
                    params: {
                        nonce: api_settings.nonce,
                        action: 'update_views_on_scroll',
                        post_id,
                    }
                });

                posts_ids_views.push(post_id);
            }
        }
    });
}